import React, { useEffect, useState } from 'react';
import { axiosInstance } from "../../utils/axios.js";
import TimeSlot from '../ReserveCom/TimeSlot';  // TimeSlotコンポーネントを作成する必要があります
import { LuCigaretteOff } from "react-icons/lu";
import { BrowserRouter, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import { FaCheckCircle } from "react-icons/fa";
import Footer from '../../components/Footer';
import { Settings, User, MapPin, FileImage, Shield, FileText, HelpCircle, ExternalLink, CheckCircle } from 'lucide-react';


const MypageOtherContainer = (props) => {
  const [reservations, setReservations] = useState([])
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (location.state?.showModal) {
      setShowModal(true);
    }
  }, [location.state]);

  const closeModal = () => {
    setShowModal(false);
  };

// インポートに追加
// JSXの差分
return (
    <div className="sunny_container">
        <div className="mypage_info container">
            <div className="settings_header">
                <Settings className="settings_header_icon" />
                <h1 className="mypage_reservation_h1">その他の設定</h1>
            </div>
            
            <div className="settings_menu">
                <NavLink to="/mypage/other/info" className="settings_menu_item">
                    <div className="menu_item_content">
                        <User className="menu_icon" />
                        <div className="menu_text">
                            <span className="menu_title">個人情報確認・編集</span>
                            <span className="menu_subtitle">基本情報の確認と変更</span>
                        </div>
                    </div>
                    <ExternalLink className="menu_arrow" />
                </NavLink>

                <NavLink to="/mypage/other/address" className="settings_menu_item">
                    <div className="menu_item_content">
                        <MapPin className="menu_icon" />
                        <div className="menu_text">
                            <span className="menu_title">配送先住所確認・編集</span>
                            <span className="menu_subtitle">お薬の配送先を管理</span>
                        </div>
                    </div>
                    <ExternalLink className="menu_arrow" />
                </NavLink>

                <NavLink to="/medichat/mypage/insurance" className="settings_menu_item">
                    <div className="menu_item_content">
                        <FileImage className="menu_icon" />
                        <div className="menu_text">
                            <span className="menu_title">資格確認書・医療証</span>
                            <span className="menu_subtitle">書類の確認とアップロード</span>
                        </div>
                    </div>
                    <ExternalLink className="menu_arrow" />
                </NavLink>

                <NavLink to="/mypage/other/medical_result" className="settings_menu_item">
                    <div className="menu_item_content">
                        <FileImage className="menu_icon" />
                        <div className="menu_text">
                            <span className="menu_title">血液検査・健康診断結果</span>
                            <span className="menu_subtitle">書類の確認とアップロード</span>
                        </div>
                    </div>
                    <ExternalLink className="menu_arrow" />
                </NavLink>

                <div className="settings_divider"></div>

                <NavLink to="https://grey-brow-5dc.notion.site/166a4be0fa708068b9fdc987a4a8edfc?pvs=4" className="settings_menu_item external">
                    <div className="menu_item_content">
                        <Shield className="menu_icon" />
                        <div className="menu_text">
                            <span className="menu_title">プライバシーポリシー</span>
                            <span className="menu_subtitle">個人情報の取り扱いについて</span>
                        </div>
                    </div>
                    <ExternalLink className="menu_arrow" />
                </NavLink>

                <NavLink to="https://grey-brow-5dc.notion.site/166a4be0fa70800f8614d0a15d38644c?pvs=4" className="settings_menu_item external">
                    <div className="menu_item_content">
                        <FileText className="menu_icon" />
                        <div className="menu_text">
                            <span className="menu_title">利用規約</span>
                            <span className="menu_subtitle">サービス利用に関する規約</span>
                        </div>
                    </div>
                    <ExternalLink className="menu_arrow" />
                </NavLink>

                <NavLink to="https://grey-brow-5dc.notion.site/166a4be0fa7080bb9cecf1bf83b8c994?pvs=4" className="settings_menu_item external">
                    <div className="menu_item_content">
                        <FileText className="menu_icon" />
                        <div className="menu_text">
                            <span className="menu_title">特定商取引法</span>
                            <span className="menu_subtitle">取引条件に関する法的事項</span>
                        </div>
                    </div>
                    <ExternalLink className="menu_arrow" />
                </NavLink>

                <NavLink to="https://customer-service-flame.vercel.app/auth" className="settings_menu_item external">
                    <div className="menu_item_content">
                        <HelpCircle className="menu_icon" />
                        <div className="menu_text">
                            <span className="menu_title">リカレ医療グループ窓口</span>
                            <span className="menu_subtitle">ご質問やご要望はこちら</span>
                        </div>
                    </div>
                    <ExternalLink className="menu_arrow" />
                </NavLink>
            </div>

            {showModal && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content success_modal" onClick={(e) => e.stopPropagation()}>
                        <span className="close-button" onClick={closeModal}>✖︎</span>
                        <div className="modal_icon success_icon">
                            <CheckCircle className="icon" />
                        </div>
                        <p className="modal_title">更新完了</p>
                        <p className="modal_subtitle">基本情報の更新が完了しました。</p>
                    </div>
                </div>
            )}
        </div>
        <Footer />
    </div>
);
};

export default MypageOtherContainer;
